import { render, staticRenderFns } from "./optionShow.vue?vue&type=template&id=3b832eba"
import script from "./optionShow.vue?vue&type=script&lang=js"
export * from "./optionShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports